export const UPDATE_STORE = 'UPDATE_STORE';
export const UPDATE_CHOSEN_TREATMENTS = 'UPDATE_CHOSEN_TREATMENTS';
export const UPDATE_CHOSEN_EMPLOYEE = 'UPDATE_CHOSEN_EMPLOYEE';
export const FETCH_PREMIUM_BUSINESS_HOURS = 'FETCH_PREMIUM_BUSINESS_HOURS';
export const UPDATE_CHOSEN_DATE = 'UPDATE_CHOSEN_DATE';
export const UPDATE_CHOSEN_TIME_ID = 'UPDATE_CHOSEN_TIME_ID';
export const UPDATE_DURATION = 'UPDATE_DURATION';
